import { render, staticRenderFns } from "./BuyUpdate.vue?vue&type=template&id=5df8a3e2&scoped=true&"
import script from "./BuyUpdate.vue?vue&type=script&lang=js&"
export * from "./BuyUpdate.vue?vue&type=script&lang=js&"
import style0 from "./BuyUpdate.vue?vue&type=style&index=0&id=5df8a3e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df8a3e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VSelect,VTextField,VTextarea})
